import { render, staticRenderFns } from "./CategoryTopFixed.vue?vue&type=template&id=ee7971f4&scoped=true&"
import script from "./CategoryTopFixed.vue?vue&type=script&lang=js&"
export * from "./CategoryTopFixed.vue?vue&type=script&lang=js&"
import style0 from "./CategoryTopFixed.vue?vue&type=style&index=0&id=ee7971f4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee7971f4",
  null
  
)

export default component.exports